import script from "./RightSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSideBar.vue?vue&type=script&setup=true&lang=js"

import "./RightSideBar.vue?vue&type=style&index=0&id=fe7f3404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe7f3404"]])

export default __exports__